/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2020-08-03 10:04:37
 * @LastEditors: chen
 * @LastEditTime: 2021-04-09 09:21:27
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { HtmlPipe } from './pipes/html.pipe';
import { ScorePipe } from './pipes/score.pipe';
import { ScoreResultPipe } from './pipes/score-result.pipe';
import { SumScorePipe } from './pipes/sum-score.pipe';
import { AlipayPipe } from './pipes/alipay.pipe';
import { TicketAndroidPipe } from './pipes/ticket-android.pipe';
import { TicketLevelPipe } from './pipes/ticket-level.pipe';

@NgModule({
  declarations: [
    HtmlPipe,
    ScorePipe,
    ScoreResultPipe,
    SumScorePipe,
    AlipayPipe,
    TicketAndroidPipe,
    TicketLevelPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule

  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzPaginationModule,
    NzTableModule,
    NzButtonModule,
    NzSwitchModule,
    NzMessageModule,
    NzUploadModule,
    NzInputModule,
    NzModalModule,
    NzSelectModule,
    HtmlPipe,
    ScorePipe,
    ScoreResultPipe,
    AlipayPipe,
    TicketAndroidPipe,
    TicketLevelPipe
  ]
})
export class ShareModule { }
